export const REPORTS_MAX_CELL_COUNT = 3000000; //3 million
